// extracted by mini-css-extract-plugin
export default {"header":"xL","light":"yL","dark":"zL","headertitle":"AL","fname":"BL","headerContent":"CL","right":"EL","descriptionwrapper":"FL","appear":"GL","second":"HL","third":"IL","forth":"JL"};
    if(module.hot) {
      // 1715091683582
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  